import { Prism } from "./index";
export function index(n) {
    function index(a, n) {
        if (n < 0 || n >= a.length) {
            return undefined;
        }
        return n;
    }
    return Prism.of({
        get: function (a) {
            var i = index(a, n);
            return i !== undefined ? a[i] : undefined;
        },
        set: function (a, v) {
            var i = index(a, n);
            if (i === undefined) {
                return a;
            }
            var copy = a.slice();
            copy[i] = v;
            return copy;
        }
    });
}
export function splice(a, i, del) {
    var add = [];
    for (var _i = 3; _i < arguments.length; _i++) {
        add[_i - 3] = arguments[_i];
    }
    return a.slice(0, i).concat(add, a.slice(i + del, a.length));
}
export function pop(a) {
    return splice(a, a.length - 1, 1);
}
export function push(a, t) {
    return splice(a, a.length, 0, t);
}
export function unshift(a, t) {
    return splice(a, 0, 0, t);
}
export function shift(a) {
    return splice(a, 0, 1);
}
//# sourceMappingURL=arrays.js.map